/**
 * Dados de navegação de retorno trazidos pelo SSO (Plataforma Verde / Azul).
 *
 * A origem (verde/azul), o id do usuário na PV e as URLs de volta chegam no
 * fragmento `#...&nav=<base64url(json)>` e ficam no localStorage para o Layout
 * montar o botão de voltar, o link do perfil e o "Sair". São por-sessão: a
 * mesma conta pode entrar pela PV numa vez e pelo H2O na outra.
 */
export interface SsoNav {
  origin?: 'verde' | 'azul';
  user_id?: number;
  home_url?: string; // voltar → origem (PV ou H2O)
  pv_url?: string; // perfil + sair → sempre PV
}

const KEY = 'envwatch_nav';

export function decodeNavParam(b64: string): SsoNav {
  try {
    // base64url → base64 (repõe o padding que o backend removeu)
    const pad = b64.length % 4 === 0 ? '' : '='.repeat(4 - (b64.length % 4));
    const json = atob(b64.replace(/-/g, '+').replace(/_/g, '/') + pad);
    const obj = JSON.parse(json);
    return obj && typeof obj === 'object' ? (obj as SsoNav) : {};
  } catch {
    return {};
  }
}

export function saveSsoNav(nav: SsoNav): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(nav));
  } catch {
    /* storage indisponível: segue sem os atalhos de retorno */
  }
}

export function loadSsoNav(): SsoNav {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as SsoNav) : {};
  } catch {
    return {};
  }
}

export function clearSsoNav(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* nada a fazer */
  }
}

/** Só permite navegar para URLs https (evita virar trampolim de redirect). */
export function safeExternalUrl(url?: string): string | null {
  if (!url) return null;
  return /^https:\/\//i.test(url) ? url : null;
}
